import React, {useState, useEffect} from "react";
import { useHistory } from "react-router-dom";

import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import LoadingButton from '@mui/lab/LoadingButton';
import AddBuildingRow from "../../components/AddBuildingRow"
import { getAllSites, getBuildingsForSite, addBuilding, addFloor } from "../../services/MetadataService";
import { sleep } from "../../utils/general"

const AddBuildingForm = (props) => {
    let [sites, setSites] = useState()
    let [existingBuildings, setExistingBuildings] = useState()
    let [selectedSite, setSelectedSite] = useState() //TODO: Default these when called from other pages
    let [isSubmitting, setIsSubmitting] = useState(false)
    let [rows, setRows] = useState(0)
    let [buildings, setBuildings] = useState({})

    let [successCount, setSuccessCount] = useState(0)

    let history = useHistory();

    useEffect(() => {
        if (!sites) {
            getAllSites(false).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setSites(response)
                if (props.siteId) {
                    let site = response.find(s => s.site_id == parseInt(props.siteId))
                    setSelectedSite(site)
                }
            })
        }

    }, [])

    useEffect(() => {
        if (selectedSite) {
            setRows(1)
            setBuildings({})

            getBuildingsForSite(selectedSite.site_id).then(response => {
                setExistingBuildings(response)
            })
        }

    },[selectedSite])

    const buildingToAddCallback = (id, building) => {
        if (!building) return;
        let currentBuildings = Object.assign({}, buildings)
        let existingBuilding = existingBuildings && existingBuildings.find(b => b.name === building.name)
        if (existingBuilding) building.error = "A building with this name already exists"

        let addingBuilding = Object.keys(buildings).find(index => index != id && buildings[index].name === building.name)
        if (addingBuilding) building.error = "You have already added this building"
        currentBuildings[id] = building;

        setBuildings(currentBuildings)
    }

    const deleteRowCallback = (id) => {

    }

    const submitAll = () => {
        let currentBuildings = Object.assign([], buildings)
        setIsSubmitting(true);
        Object.keys(buildings).forEach(i => {
            let b = buildings[i]
            if (b.name && b.floors) {
                addBuilding(b).then(async response => {
                    currentBuildings[i].success = true
                    currentBuildings[i].error = null

                    let floors_added = 0;
                    if (b.hasBasement) {
                        try {
                            let floor = await addFloor({
                                name: "Basement",
                                building_id: response.id,
                                floor_type: "Basement",
                            })
                            floors_added++
                        } catch (err) {
                            console.log(err)
                        }
                    }

                    for(let i=1; i <= b.floors; i++) {
                        try {
                            await addFloor({
                                name: "Floor " + i,
                                building_id: response.id,
                                floor_type: "Floor",
                            })
                            floors_added++;

                            if (floors_added >= b.floors) {
                                setSuccessCount(successCount + 1)
                            }
                        } catch (err) {
                            debugger;
                            console.log("Retrying...")
                            console.log(err)
                            setTimeout(() => {
                                try {
                                    addFloor({
                                        name: "Floor " + i,
                                        building_id: response.id,
                                        floor_type: "Floor",
                                    })
                                } catch (err2) {
                                    debugger;
                                    console.log("Still failed floor " + i)
                                    console.log(err2)
                                }

                            }, 1000)
                        }
                    }

                    setBuildings(currentBuildings)
                    setIsSubmitting(false);
                }).catch(err => {
                    console.log(err)
                    currentBuildings[i].success = false
                    currentBuildings[i].error = "Row was not added"
                    setIsSubmitting(false);
                })
            } else {
                currentBuildings[i].success = false
                currentBuildings[i].error = "Please fill out all required fields."
            }
        })

        setBuildings(currentBuildings)
    }

    if (!sites || (props.siteId && !selectedSite)) return null;

    //TODO: Redirect to buildings list page with site selected
    //If some fail, highlight the failures
    if (successCount === rows && rows != 0) {
        if (rows > 0) {
            history.push("/buildings?site_id=" + selectedSite.site_id)
        } else if (rows == 1) {
            //TODO: Redirect to the space except we don't know what it is currently
        }

    }

    let addRows = [];
    for (let i = 0; i < rows; i++) {
        let building = buildings[i] || {
            site_id: selectedSite.site_id,
            floor_to_ceiling_height: selectedSite.floor_to_ceiling_height
        }

        let key = "site_" + selectedSite.site_id + "_building_" + i
        addRows.push(
            <AddBuildingRow key={key} row_num={i} callback={buildingToAddCallback} building={building} />
        )
    }

    let initialSite = selectedSite && sites.find(s => s.site_id == props.siteId)

    return (
        <div className="layer3">
            <div className="bulk-add-form">
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="sites"
                        options={sites}
                        getOptionLabel={option => option.name}
                        defaultValue={initialSite}
                        renderInput={(params) => <TextField {...params} value={selectedSite && selectedSite.name} label="Site" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSite(newValue);
                        }}
                    />
                </div>


            {
                selectedSite  ?
                <div className="add-container">
                    <div className="instructions">Enter buildings for this site:</div>
                    {
                        addRows
                    }

                    <div className="form-buttons">
                        <div className="form-button-left" onClick={() => setRows(rows+1)}>Add Row</div>
                        <div className="form-button-container-right">
                            <LoadingButton variant="contained" loading={isSubmitting} type="submit" onClick={submitAll}  style={{backgroundColor: "#003e51"}}>
                                    Submit
                            </LoadingButton>
                        </div>
                    </div>
                </div> : null
            }

            </div>
        </div>

    )


}

export default AddBuildingForm;